import { useState, type CSSProperties } from 'react'
import { cx } from '@/lib/cx'
import { frameSources } from '@/lib/decor'
import { STATUS_LABEL } from '@/lib/presence'
import type { AvatarDecoration } from '@/types/api'
import { StatusIcon } from './StatusIcon'
import styles from './Avatar.module.css'

export type Status = 'online' | 'idle' | 'dnd' | 'offline' | 'invisible'

interface Props {
  initial: string
  color: string
  size?: number
  status?: Status | undefined
  speaking?: boolean
  className?: string | undefined
  /** URL картинки; при ошибке загрузки показываем инициал. */
  src?: string | undefined
  /** Рамка аватара (украшение профиля); не загрузилась — аватар без рамки. */
  decoration?: AvatarDecoration | null | undefined
}

export function Avatar({ initial, color, size = 32, status, speaking, className, src, decoration }: Props) {
  const [brokenSrc, setBrokenSrc] = useState<string | null>(null)
  const [brokenFrame, setBrokenFrame] = useState<string | null>(null)
  const style = { '--size': `${size}px`, background: color } as CSSProperties
  const showImage = Boolean(src) && brokenSrc !== src
  const frame = decoration && brokenFrame !== decoration.asset ? frameSources(decoration, size) : null
  return (
    <span className={cx(styles.avatar, className)} style={style} data-speaking={speaking ? '' : undefined} aria-hidden="true">
      {showImage ? <img className={styles.image} src={src} alt="" onError={() => setBrokenSrc(src ?? null)} /> : initial}
      {frame ? (
        <img
          className={styles.frame}
          src={frame.src}
          srcSet={frame.srcSet}
          sizes={frame.sizes}
          alt=""
          draggable={false}
          onError={() => setBrokenFrame(decoration?.asset ?? null)}
        />
      ) : null}
      {status ? (
        <span className={styles.status} data-tooltip={STATUS_LABEL[status]}>
          <StatusIcon status={status} label={STATUS_LABEL[status]} />
        </span>
      ) : null}
    </span>
  )
}
